import { Icon } from '@iconify/react'
import type { LandingPremiatedNumberItem } from '@/types/landing'
import listStyles from './LandingPremiatedNumbersList.module.css'

type LandingPremiatedNumbersListProps = {
  items: LandingPremiatedNumberItem[]
  visualVariant: 'light' | 'dark'
}

export function LandingPremiatedNumbersList({ items, visualVariant }: LandingPremiatedNumbersListProps) {
  if (items.length === 0) {
    return null
  }

  const listThemeClass = visualVariant === 'dark' ? listStyles.rootDark : ''

  return (
    <div className={listThemeClass}>
      <ul className={listStyles.list}>
        {items.map((item, index) => {
          const hasWinner = Boolean(item.winner_display_name?.trim())
          return (
            <li key={`${item.number}-${index}`} className={listStyles.row}>
              <div className={listStyles.rowMain}>
                <div
                  className={`${listStyles.statusIcon} ${
                    hasWinner ? listStyles.statusWon : listStyles.statusPending
                  }`}
                  aria-hidden
                >
                  <Icon icon={hasWinner ? 'mdi:check-decagram' : 'mdi:circle-outline'} />
                </div>
                <div className={listStyles.winnerBlock}>
                  {hasWinner ? (
                    <p className={listStyles.winnerLabel}>{item.winner_display_name}</p>
                  ) : (
                    <p className={listStyles.winnerPending}>Sem ganhador</p>
                  )}
                  {item.prize_description ? (
                    <p className={listStyles.prizeBadge}>{item.prize_description}</p>
                  ) : null}
                </div>
              </div>
              <div className={listStyles.numberBlock}>
                <span className={listStyles.numberLabel}>Número</span>
                <p className={listStyles.numberValue}>{item.number}</p>
              </div>
            </li>
          )
        })}
      </ul>
      <p className={listStyles.footer}>
        {items.length} {items.length === 1 ? 'título premiado' : 'títulos premiados'}
      </p>
    </div>
  )
}
